Librarian.Modules.Activity = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["loadData", "onActivitiesLoaded", "onPortalsLoaded",
            "slideItemIn", "showActivityView", "updateList"],

    options: {
        classPrefix: "modules-activity-",
        count: 50,
        updateInterval: 30000,
        slideDuration: 1200,
        slideDelay: 500,
        slideInDifferential: true,
        eventId: null,
        title: "Activities", // A placeholder that will go away if everything works correctly
        logTypes: [
            Librarian.activityLogType.preview,
            Librarian.activityLogType.download,
            Librarian.activityLogType.search,
            Librarian.activityLogType.openEmail,
            Librarian.activityLogType.clickLink,
            Librarian.activityLogType.shareEvent
        ]
    },

    listEl: null,
    filterEl: null,
    viewTypeEl: null,
    typeFilterEl: null,
    dateFilterEl: null,
    activityEls: [],

    eventDate: null,
    loadTimer: null,

    filterValue: null,
    activityLogType: null,
    // "recent" - Recent Portal Activity
    // "active" - Most Active Portals
    // "active_chart" - Most Active Portals Chart
    currentView: "recent",
    delayCount: 0,

    hasLoaded: false,
    filterText: null,

    initialize: function(options, wrapperEl) {
        this.setOptions(options);

        if (this.options.eventId == null)
            this.filterText = "modules_activity_filter_default";
        else
            this.filterText = "modules_activity_contact_filter_default";

        this.parent(this.options, wrapperEl);
    },

    destroy: function() {
        for (var i = this.activityEls.length; i--;) {
            if (this.activityEls[i]) {
                $(this.activityEls[i]).destroy();
                this.activityEls[i] = null;
            }
        }

        if (this.loadTimer) {
            clearTimeout(this.loadTimer);
            this.loadTimer = null;
        }

        var elements = [this.listEl, this.filterEl, this.viewTypeEl, this.typeFilterEl, this.dateFilterEl];
        for (var i = elements.length; i--;) {
            if (elements[i]) {
                $(elements[i]).destroy();
                elements[i] = null;
            }
        }

        this.eventDate = null;
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        this.listEl = new Element("ul", {
            "class": (this.options.classPrefix || '') + "list"
        }).injectInside(this.containerEl);

        this.headerEl.empty();

        // Add view type dropdown
        var viewTypes = ["recent"];
        if (this.options.eventId == null) {
            viewTypes.push("active");
            //viewTypes.push("active_chart");
        }

        this.viewTypeEl = this.createDropdown("ico-activity-menu", this.options.id + "_view", viewTypes, "modules_activity_view_", this.showActivityView);

        // Add activity filter dropdown
        var typeFilters = ["all", "clickLink", "openEmail", "download", "shareEvent"];

        this.typeFilterEl = this.createDropdown("ico-activity-filter", this.options.id + "_activity", typeFilters, "modules_activity_filter_", function(type) {
            this.activityLogType = Librarian.activityLogType[type];
            this.eventDate = null;
            this.updateList();
        }.bind(this), Librarian.Lang.getString("modules_activity_filter_prefix"));

        // Add date filter dropdown
        var dateFilters = ["all", "7", "30", "60"];

        this.dateFilterEl = this.createDropdown("ico-activity-filter", this.options.id + "_date", dateFilters, "modules_activity_date_filter_", function(date) {
            var days = date.toInt();
            if (isNaN(days))
                this.eventDate = null;
            else {
                this.eventDate = new Date();
                this.eventDate.setDate(this.eventDate.getDate() - days);
            }

            this.updateList();
        }.bind(this), Librarian.Lang.getString("modules_activity_filter_prefix"));
        this.dateFilterEl.hide();

        // Add filter box
        this.filterEl = new Element("input[type=text]", {
            "class": (this.options.classPrefix || '') + "filter",
            "value": Librarian.Lang.getString(this.filterText),
            "spellcheck": "true"
        }).injectInside(this.headerEl);

        // If the default value is still there when the user clicks into the box, clear it
        this.filterEl.addOnClick(function() {
            var value = Librarian.Utils.getElementValue(this.filterEl);
            if (value === Librarian.Lang.getString(this.filterText))
                Librarian.Utils.setElementValue(this.filterEl, '');
        }, this);
        // If the box is empty when the user clicks out of it, re-add the default value
        this.filterEl.addEvent("blur", function() {
            var value = Librarian.Utils.getElementValue(this.filterEl);
            if (!value || (value.length == 0)) {
                this.filterEl.set("text", Librarian.Lang.getString(this.filterText));
                this.filterValue = null;
            }
            else
                this.filterValue = value;
        }.bind(this));
        // If the user presses enter while they are in the box, get the latest filter value and update the list
        this.filterEl.addEvent("keydown", function(e) {
            var evt = new Event(e);
            if (evt.key === "enter") {
                this.filterValue = Librarian.Utils.getElementValue(this.filterEl);
                this.eventDate = null;
                this.updateList();
            }
        }.bind(this));

        new Element("input[type=button]", {
            "class": (this.options.classPrefix || '') + "filter-button button",
            "value": Librarian.Lang.getString("go")
        }).injectInside(this.headerEl).addOnClick(function() {
            this.eventDate = null;
            this.updateList();
        }, this);

        this.loadData();
    },

    createDropdown: function(iconClass, baseId, items, langPrefix, onClick, textPrefix) {
        var viewsEl = new Element("ul", {
                "class": "sddm"
            }).injectInside(this.headerEl),
            viewEl = new Element("li").injectInside(viewsEl),
            triggerEl = new Element("a", {
                "class": iconClass,
                "id": baseId + "Trigger"
            }).injectInside(viewEl),
            targetEl = new Element("div", {
                "id": baseId + "Menu"
            }).injectInside(viewEl);

        triggerEl.menuId = targetEl.id;
        triggerEl.addEvent("mouseout", mclosetime).addEvent("mouseover", function() {
            mopen(this.menuId);
        });

        targetEl.addEvent("mouseover", mcancelclosetime).addEvent("mouseout", mclosetime).addEvent("blur", mclosetime);

        for (var i = 0; i < items.length; i++) {
            var itemText = Librarian.Lang.getString((langPrefix || '') + items[i]);
            if (i == 0)
                Librarian.Utils.setElementValue(triggerEl, (textPrefix || '') + itemText);

            var itemEl = new Element("a", {
                "text": itemText
            }).injectInside(targetEl);

            itemEl.textPrefix = textPrefix;
            itemEl.triggerId = triggerEl.id;
            itemEl.onClickFn = onClick;
            itemEl.value = items[i];
            itemEl.addOnClick(this.onDropDownItemClicked, itemEl);
        }

        return viewsEl;
    },

    onDropDownItemClicked: function() {
        if (typeof this.onClickFn == "function")
            this.onClickFn(this.value);

        var triggerEl = $(this.triggerId);
        if (!triggerEl)
            return;

        Librarian.Utils.setElementValue(triggerEl, (this.textPrefix || '') + this.get("text"));
    },

    showActivityView: function(viewType) {
        if (this.currentView == viewType)
            return;

        this.typeFilterEl[(viewType == "recent") ? "show" : "hide"]();
        this.dateFilterEl[(viewType == "recent") ? "hide" : "show"]();
        this.listEl.empty();
        this.activityLogType = null;
        this.eventDate = null;
        this.currentView = viewType;
        this.filterText = (viewType == "recent") ? ((this.options.eventId == null) ? "modules_activity_filter_default" : "modules_activity_contact_filter_default") : "modules_activity_portal_filter_default";
        var otherText = (viewType == "recent") ? "modules_activity_portal_filter_default" : ((this.options.eventId == null) ? "modules_activity_filter_default" : "modules_activity_contact_filter_default");

        var value = Librarian.Utils.getElementValue(this.filterEl);
        if (value === Librarian.Lang.getString(otherText))
            this.filterEl.set("text", Librarian.Lang.getString(this.filterText));

        this.updateList();
    },

    updateList: function() {
        this.listEl.empty();

        for (var i = this.activityEls.length; i--;) {
            if (this.activityEls[i]) {
                $(this.activityEls[i]).destroy();
                this.activityEls[i] = null;
                this.activityEls.remove(i);
            }
        }

        this.loadData();
    },

    loadData: function() {
        if (this.loadTimer) {
            clearTimeout(this.loadTimer);
            this.loadTimer = null;
        }

        // If this is the normal view, load everything as usual
        if (this.currentView == "recent")
            this.request = Librarian.Events.getEventActivities(this.options.eventId, this.eventDate ? encodeURIComponent(this.eventDate.toISOString()) : null, null, this.options.count, this.filterValue, this.activityLogType || this.options.logTypes, "ujson", this.onActivitiesLoaded);
        // Otherwise, load the portals list
        else
            this.request = Librarian.Events.getEventActivityData(this.eventDate ? encodeURIComponent(this.eventDate.toISOString()) : null, null, this.options.count, this.filterValue, "ujson", this.onPortalsLoaded);
    },

    onActivitiesLoaded: function(json) {
        this.loadTimer = setTimeout(this.loadData.bind(this), this.options.updateInterval);

        if (!json || !json.List)
            return;

        // Save this date as the last date
        this.eventDate = Librarian.Utils.extractDateFromString(json.CurrentTime);
        // If we already have activities, this is a differential load
        var isDifferential = (this.activityEls.length > 0);

        // Go through each activity, create a display for its data, and add it to the list
        for (var i = json.List.length; i--;) {
            var activity = json.List[i],
                listItemEl = new Element("li", {
                    "class": (this.options.classPrefix || '') + "item"
                }),
                date = Librarian.Utils.extractDateFromString(activity.LogDate),
                prettyDate = date.toPrettyFormat(this.eventDate);

            new Element("span", {
                "class": (this.options.classPrefix || '') + "icon ico-activity"
            }).injectInside(listItemEl);
            // Save the date into the date element so we can update all the dates later
            var dateEl = new Element("span", {
                "class": (this.options.classPrefix || '') + "date",
                "text": prettyDate
            }).injectInside(listItemEl);
            dateEl.date = date;

            this.addUserElement(activity, listItemEl);
            new Element("span", {
                "class": (this.options.classPrefix || '') + "action",
                "text": this.getActionText(activity.LogType)
            }).injectInside(listItemEl);
            this.addItemElement(activity, listItemEl);

            this.activityEls = Array.pushTop(this.activityEls, listItemEl);

            // If this is a differential load, slide the new element in from the side
            if (isDifferential && this.options.slideInDifferential) {
                if (i == (json.List.length - 1))
                    this.slideItemIn(listItemEl);
                else {
                    this.delayCount++;
                    this.slideItemIn.delay(this.options.slideDelay * this.delayCount, this, [listItemEl]);
                }
            }
            else
                listItemEl.injectTop(this.listEl);
        }

        if (!this.hasLoaded)
            this.hasLoaded = true;
        else {
            // Reload all the dates with the latest offsets
            var dateEls = $$('.' + (this.options.classPrefix || '') + "date");
            for (var i = dateEls.length; i--;) {
                if (dateEls[i] && dateEls[i].date)
                    Librarian.Utils.setElementValue(dateEls[i], dateEls[i].date.toPrettyFormat());
            }
        }

        // Check how many we are over the maximum
        var removeCount = this.activityEls.length - this.options.count;
        // If we're not, don't continue
        if (removeCount < 0)
            return;

        // Otherwise, remove from the bottom until we're at the maximum
        for (var i = this.activityEls.length; i-- && removeCount--;) {
            if (this.activityEls[i])
                $(this.activityEls[i]).destroy();
        }

        // Chop the removed elements out of the array now that we're done
        this.activityEls.remove(this.options.count, this.activityEls.length);
    },

    slideItemIn: function(listItemEl) {
        listItemEl.injectTop(this.listEl);

        if (this.delayCount > 0)
            this.delayCount--;

        new Fx.Slide(listItemEl, {
            "mode": "horizontal",
            "duration": this.options.slideDuration
        }).hide().toggle();
    },

    getActionText: function(logType) {
        switch (logType) {
            case Librarian.activityLogType.preview:
                return Librarian.Lang.getString("activity_preview");
            case Librarian.activityLogType.download:
                return Librarian.Lang.getString("activity_download");
            case Librarian.activityLogType.search:
                return Librarian.Lang.getString("activity_search");
            case Librarian.activityLogType.sessionActivity:
                return Librarian.Lang.getString("activity_generic");
            case Librarian.activityLogType.open:
                return Librarian.Lang.getString("activity_open");
            case Librarian.activityLogType.openEmail:
                return Librarian.Lang.getString("activity_openemail");
            case Librarian.activityLogType.clickLink:
                return Librarian.Lang.getString("activity_click");
            case Librarian.activityLogType.shareEvent:
                return Librarian.Lang.getString("activity_share");
        }

        return '';
    },

    onPortalsLoaded: function(json) {
        this.loadTimer = setTimeout(this.loadData.bind(this), this.options.updateInterval);

        if (!json)
            return;

        this.listEl.empty();

        for (var i = 0; i < json.length; i++) {
            var activity = json[i],
                listItemEl = new Element("li", {
                    "class": (this.options.classPrefix || '') + "item"
                }).injectInside(this.listEl);

            new Element("span", {
                "class": (this.options.classPrefix || '') + "icon ico-portal"
            }).injectInside(listItemEl);
            new Element("span", {
                "class": (this.options.classPrefix || '') + "count",
                "text": Librarian.Lang.getPluralArgString("modules_activity_count", activity.Total, [activity.Total])
            }).injectInside(listItemEl);

            this.addItemElement(activity, listItemEl);

            this.activityEls = Array.pushTop(this.activityEls, listItemEl);
        }
    },

    addUserElement: function(activity, listItemEl) {
        var userEl = new Element("span", {
            "class": (this.options.classPrefix || '') + "user",
            "text": activity.DisplayName
        }).injectInside(listItemEl);

        // Save the client portion of the activity data for later
        userEl.client = Librarian.Contacts.getContactFromJSON(Object.toLowerKeys(activity));
        userEl.addOnClick(function() {
            var win = new Librarian.ContactDetailWindow(this.client, {
                    id: "ContactDetailWindow" + (new Date().getTime()),
                    index: contactDetailWindows.length,
                    onCloseComplete: function() {
                        contactDetailWindows.remove(this.options.index);

                        for (var i = 0; i < contactDetailWindows.length; i++)
                            contactDetailWindows[i].options.index = i;
                    }
                });

            contactDetailWindows.push(win);
        });
    },

    addItemElement: function(activity, listItemEl) {
        var itemEl = new Element("span").injectInside(listItemEl);

        // If this has content
        if (activity.ContentName) {
            // Get its extension and figure out its type
            var ext = Librarian.Utils.getExtension(activity.ContentName).toLowerCase(),
                type = "presentation";
            if (Librarian.extensions.isVideo(ext))
                type = "video";
            else if (Librarian.extensions.isAudio(ext))
                type = "audio";
            else if (Librarian.extensions.isImage(ext))
                type = "image";
            else if (Librarian.extensions.isWordFile(ext) || (ext === "pdf") || Librarian.extensions.isExcelFile(ext))
                type = "document";
            else if (activity.ContentText == "SlideShow Player View")
                type = "slideshow";

            // Set the type as the starting text
            itemEl.set("text", Librarian.Lang.getString(type).toLowerCase());

            var subLength = (ext.length > 0) ? (ext.length + 1) : 0,
                // Set the name of the file as a new element without the PDF
                nameEl = new Element("span", {
                    "class": (this.options.classPrefix || '') + "subject",
                    "text": activity.ContentName.substring(0, activity.ContentName.length - subLength)
                }).injectInside(itemEl);

            // Save the data for this content
            var data = {
                ext: ext,
                contenttype: activity.ContentType,
                contentsubtype: activity.ContentSubType
            };

            // Treat Favorites differently
            if (activity.ContentType == Librarian.contentType.myFavorite) {
                data.presid = activity.ContentId;
                data.name = activity.ContentName;
            }
            else if (activity.ContentType == Librarian.contentType.globalFavorite) {
                data.groupid = activity.ContentId;
                data.name = activity.ContentName;
            }
            else {
                data.fileid = activity.ContentId;
                data.filename = activity.ContentName;
            }

            nameEl.data = data;
            // Open a preview window when this is clicked
            nameEl.addOnClick(function() {
                // If this is a slideshow or a shared slideshow, open the player
                if ((this.data.contenttype == Librarian.contentType.myFavorite) && [Librarian.virtPresType.slideshow, Librarian.virtPresType.sharedSlideshow].contains(this.data.contentsubtype))
                    Librarian.Utils.openSlideShow(this.data, "player");
                else
                    Librarian.PreviewWindow.openPreviewWindow(this.data);
                return false;
            });
        }
        else {
            // Add the class
            itemEl.addClass((this.options.classPrefix || '') + "subject");
            // Set the subject as the text
            var name = activity.Subject;
            if (!name || (name.length == 0))
                name = Librarian.Lang.getArgString("modules_activity_unnamed", [Librarian.Utils.extractDateFromString(activity.SendDate).format("%m/%d/%Y")]);
            Librarian.Utils.setElementValue(itemEl, name);

            // Load the details window for this event
            itemEl.eventid = activity.EventId;
            itemEl.addOnClick(function() {
                var managerWindow = new Librarian.EventManagerWindow();
                managerWindow.show();

                if (this.eventid > 0) {
                    var detailWindow = new Librarian.EventDetailsWindow({
                        eventId: this.eventid,
                        grid: managerWindow.grid
                    });

                    detailWindow.show();
                }

                return false;
            });

            // IF this was a share, add the share count to the text
            if (activity.LogType == Librarian.activityLogType.shareEvent) {
                new Element("span", {
                    "text": Librarian.Lang.getPluralArgString("activity_share_with", activity.Count, [activity.Count])
                }).injectInside(listItemEl);
            }
        }
    }
});